import { render, staticRenderFns } from "./ShippingDivisions.vue?vue&type=template&id=013b7db0&"
import script from "./ShippingDivisions.vue?vue&type=script&lang=js&"
export * from "./ShippingDivisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports